import { render, staticRenderFns } from "./MenuContent.vue?vue&type=template&id=4092b2c1&scoped=true&"
import script from "./MenuContent.vue?vue&type=script&lang=js&"
export * from "./MenuContent.vue?vue&type=script&lang=js&"
import style0 from "./MenuContent.vue?vue&type=style&index=0&id=4092b2c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4092b2c1",
  null
  
)

export default component.exports